export const ERROR_TYPES = {
  NETWORK_ERROR: "NETWORK_ERROR",
  TIMEOUT: "TIMEOUT",
  HTTP_ERROR: "HTTP_ERROR",
  EMPTY_RESPONSE: "EMPTY_RESPONSE",
  INVALID_JSON: "INVALID_JSON",
  CONTRACT_ERROR: "CONTRACT_ERROR",
  UNKNOWN: "UNKNOWN",
};

const USER_MESSAGES = {
  [ERROR_TYPES.NETWORK_ERROR]:
    "No fue posible completar la operación. Verifique su conexión e intente nuevamente.",
  [ERROR_TYPES.TIMEOUT]:
    "No fue posible completar la operación. Verifique su conexión e intente nuevamente.",
  [ERROR_TYPES.HTTP_ERROR]:
    "El servicio no está disponible en este momento. Intente más tarde.",
  [ERROR_TYPES.EMPTY_RESPONSE]:
    "Recibimos una respuesta inesperada. Intente nuevamente o contacte al comercio.",
  [ERROR_TYPES.INVALID_JSON]:
    "Recibimos una respuesta inesperada. Intente nuevamente o contacte al comercio.",
  [ERROR_TYPES.CONTRACT_ERROR]:
    "Recibimos una respuesta inesperada. Intente nuevamente o contacte al comercio.",
  [ERROR_TYPES.UNKNOWN]:
    "Ocurrió un error al procesar la solicitud. Por favor intente más tarde.",
};

const SENSITIVE_PATTERNS = [
  /https?:\/\/[^\s]+/gi,
  /eks-[^\s]+/gi,
  /Error:\s*.+/gi,
  /at\s+[^\n]+/gi,
  /stack\s*trace/gi,
  /Bearer\s+[^\s]+/gi,
  /token[=:]\s*[^\s]+/gi,
];

export function sanitizeBackendMessage(text) {
  if (!text || typeof text !== "string") {
    return null;
  }

  let sanitized = text.trim();
  if (!sanitized) {
    return null;
  }

  SENSITIVE_PATTERNS.forEach((pattern) => {
    sanitized = sanitized.replace(pattern, "");
  });

  sanitized = sanitized.trim();
  if (!sanitized || sanitized.length < 3) {
    return null;
  }

  return sanitized;
}

export function createIntegrationError(errorType, options = {}) {
  const {
    statusCode,
    endpoint,
    originalMessage,
    retryable = true,
    backendMessage,
  } = options;

  const sanitizedBackend = sanitizeBackendMessage(backendMessage);
  const userMessage =
    sanitizedBackend || USER_MESSAGES[errorType] || USER_MESSAGES[ERROR_TYPES.UNKNOWN];

  return {
    errorType,
    userMessage,
    retryable,
    statusCode,
    endpoint,
    originalMessage,
    isIntegrationError: true,
  };
}

export function classifyFetchError(error, statusCode) {
  if (error && error.name === "AbortError") {
    return ERROR_TYPES.TIMEOUT;
  }

  if (error && error.errorType) {
    return error.errorType;
  }

  if (statusCode >= 500) {
    return ERROR_TYPES.HTTP_ERROR;
  }

  if (statusCode >= 400) {
    return ERROR_TYPES.HTTP_ERROR;
  }

  if (
    error instanceof TypeError ||
    (error && error.message && /network|failed to fetch/i.test(error.message))
  ) {
    return ERROR_TYPES.NETWORK_ERROR;
  }

  return ERROR_TYPES.UNKNOWN;
}

export function normalizeIntegrationError(error, context = {}) {
  if (error && error.isIntegrationError) {
    return error;
  }

  const statusCode =
    (error && error.response && error.response.status) ||
    context.statusCode ||
    null;

  const errorType = classifyFetchError(error, statusCode);

  return createIntegrationError(errorType, {
    statusCode,
    endpoint: context.endpoint,
    originalMessage: error && error.message,
    retryable: errorType !== ERROR_TYPES.CONTRACT_ERROR || true,
    backendMessage: context.backendMessage,
  });
}
